/* jshint node:true */
  'use strict';

  var Stream = function (_Transform) {
    throw new Error("jsonexport called without third argument as a callback and is required")
  }

  module.exports = Stream;
  